import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { getDaysSinceUserSignup } from 'mini-common-utils/lib/utils/getDaysSinceUserSignUp';
import { getGreenRoomStore } from 'mini-mail-greenroom/lib/store';
import { GreenRoomEnum } from 'mini-mail-greenroom/lib/utils/greenRoomEnum';

const ACCOUNT_AGE_THRESHOLD_IN_DAYS = 30;
const GREEN_ROOM_CONTROL_FLAG = false; //Switch to disable / enable greenroom
export function shouldShowGreenRoom(tableView: TableView): boolean {
    const focusedFilter = getFocusedFilterForTable(tableView);
    const isInbox = tableView.tableQuery.folderId === folderNameToId('inbox');
    const isGreenRoomVisible = getGreenRoomStore().showGreenRoom === GreenRoomEnum.Visible;
    const isAccountOldEnough = getDaysSinceUserSignup() >= ACCOUNT_AGE_THRESHOLD_IN_DAYS;
    return (
        (focusedFilter === FocusedViewFilter.Focused || focusedFilter === FocusedViewFilter.None) &&
        isInbox &&
        isGreenRoomVisible &&
        isAccountOldEnough &&
        GREEN_ROOM_CONTROL_FLAG
    );
}
